import React from "react";
import UnifiedTableFilter, { FilterValue, FilterConfig, FilterActions, DataViewMode } from "@/components/cards/widgets/TableFilter";

interface GridControlsProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterConfig?: FilterConfig[];
  activeFilters: FilterValue[];
  onFiltersChange: (filters: FilterValue[]) => void;
  filterActions?: Partial<FilterActions>;
  shadowMode: "none" | "black" | "status" | "template" | "folder";
  onShadowModeChange: (mode: "none" | "black" | "status" | "template" | "folder") => void;
  viewMode?: "grid" | "table" | "flow";
  onViewModeChange?: (mode: "grid" | "table" | "flow") => void;
  allowFlowView?: boolean; // Whether to show flow view option
  // Data view mode props
  dataViewMode?: DataViewMode;
  onDataViewModeChange?: (mode: DataViewMode) => void;
}

export default function GridControls({
  searchTerm,
  onSearchChange,
  filterConfig,
  activeFilters,
  onFiltersChange,
  filterActions,
  shadowMode,
  onShadowModeChange,
  viewMode,
  onViewModeChange,
  allowFlowView = false,
  dataViewMode,
  onDataViewModeChange,
}: GridControlsProps) {
  return (
    <div className="flex flex-col gap-4">
      {/* Unified Filter Bar */}
      <UnifiedTableFilter
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        availableFilters={filterConfig || []}
        activeFilters={activeFilters}
        onFiltersChange={onFiltersChange}
        actions={filterActions}
        shadowMode={shadowMode}
        onShadowModeChange={onShadowModeChange}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        allowFlowView={allowFlowView}
        dataViewMode={dataViewMode}
        onDataViewModeChange={onDataViewModeChange}
      />
    </div>
  );
}

